import { DOOH_REPORT_SUMMARY_LOADED } from './config';

const reducer = (state = null, action) => {
    switch (action.type) {
        case DOOH_REPORT_SUMMARY_LOADED:
            return action.payload;
        
        default:
            return state;
    }
}

export default reducer;